import { isBotUserAgent } from '@core/utils';

/**
 * 현재 클라이언트의 User-Agent가 검색·SNS·메신저 봇인지 판정.
 * SSR(navigator 없음)에서는 false → hydration 일관성 유지.
 * 봇 가드용 (트래킹/피드백/폴링 등 사용자 행위성 fetch 조기 차단).
 */
export const isBot = (): boolean =>
  typeof navigator !== 'undefined' && isBotUserAgent(navigator.userAgent);
